import React, { useState } from 'react';
import axios from 'axios';
import { trackFormSubmission, trackLeadGeneration } from '../utils/analytics';
import './LeadForm.css';
import Turnstile from './Turnstile';

const LeadForm = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    numberOfLocations: '',
    contactName: '',
    phone: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [token, setToken] = useState('');
  const [verificationReset, setVerificationReset] = useState(0);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token || isSubmitting) return;
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await axios.post('https://thx8odn37g.execute-api.us-west-2.amazonaws.com/prod/submit-lead', {
        ...formData,
        'cf-turnstile-response': token
      });

      // Track successful form submission
      trackFormSubmission('contact_form');
      trackLeadGeneration({ form_name: 'strategy_call' });

      setSubmitStatus('success');
      setFormData({
        companyName: '',
        numberOfLocations: '',
        contactName: '',
        phone: '',
        email: ''
      });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setToken('');
      setVerificationReset(value => value + 1);
    }

    setIsSubmitting(false);
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-background">
        <div className="gradient-bg"></div>
      </div>

      <div className="contact-container">
        <div className="contact-content">
          <div className="contact-info">
            <h2>Ready to Transform Your Salon Intelligence?</h2>
            <p className="contact-subtitle">
              Get your free strategy call and see how we can eliminate your manual reporting.
            </p>

            <div className="benefits-list">
              <div className="benefit-item">
                <div className="benefit-icon">🎯</div>
                <div>
                  <h4>Free Strategy Call</h4>
                  <p>Personalized consultation for your business</p>
                </div>
              </div>

              <div className="benefit-item">
                <div className="benefit-icon">⚡</div>
                <div>
                  <h4>Quick Setup</h4>
                  <p>Operational in 30 days or less</p>
                </div>
              </div>

              <div className="benefit-item">
                <div className="benefit-icon">💡</div>
                <div>
                  <h4>Expert Support</h4>
                  <p>Dedicated team throughout implementation</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <form onSubmit={handleSubmit} className="modern-form">
              <div className="form-group">
                <label htmlFor="companyName">Company Name</label>
                <input
                  id="companyName"
                  type="text"
                  name="companyName"
                  placeholder="Your Company"
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="numberOfLocations">Number of Locations</label>
                <select
                  id="numberOfLocations"
                  name="numberOfLocations"
                  value={formData.numberOfLocations}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select range</option>
                  <option value="2-5">2-5 locations</option>
                  <option value="6-10">6-10 locations</option>
                  <option value="11-25">11-25 locations</option>
                  <option value="25+">25+ locations</option>
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="contactName">Your Name</label>
                  <input
                    id="contactName"
                    type="text"
                    name="contactName"
                    placeholder="John Doe"
                    value={formData.contactName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    id="phone"
                    type="tel"
                    name="phone"
                    placeholder="(555) 123-4567"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="your.email@company.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <Turnstile action="turnstile-spin-v2" onToken={setToken} resetKey={verificationReset} />
              <button
                type="submit"
                disabled={isSubmitting || !token}
                className="submit-btn"
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner"></span>
                    Submitting...
                  </>
                ) : 'Book Your Strategy Call'}
              </button>

              {submitStatus === 'success' && (
                <div className="success-message">
                  <span>✓</span> Thank you! We'll contact you within 24 hours.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="error-message">
                  <span>✗</span> Error submitting form. Please try again.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadForm;
